/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'schedule': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2.815 21.164H22.14a.94.94 0 01.678.28.982.982 0 010 1.377.935.935 0 01-.677.279H2.815C1.777 23.1.9 22.23.9 21.174V1.887a.988.988 0 01.266-.692.934.934 0 011.353-.006c.179.184.277.437.272.696v19.283c.002-.002.008-.004.024-.004zm4.912-10.701l2.282-4.95a.948.948 0 01.799-.545.944.944 0 01.917.565l3.632 8.151 1.126-2.645a.946.946 0 01.867-.576h4.79a.934.934 0 01.679.28.98.98 0 010 1.376.933.933 0 01-.677.28H17.97l-1.727 4.042a.947.947 0 01-.856.581.946.946 0 01-.87-.561l-3.662-8.232-1.67 3.614a.946.946 0 01-.857.556H5.512a.934.934 0 01-.678-.28.976.976 0 01-.282-.689c0-.259.102-.507.282-.688a.934.934 0 01.677-.28h2.216z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
